const Button = ({ children, variant = "primary", className = "", href, onClick, ...props }) => {
  const baseClasses =
    "inline-flex items-center justify-center px-6 py-3 rounded-xl font-medium transition-all duration-300 transform active:scale-95 cursor-pointer";
  const variants = {
    primary:
      "bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-600 text-white font-semibold shadow-lg shadow-indigo-500/25 hover:shadow-indigo-500/40 hover:scale-[1.02]",
    secondary:
      "bg-gray-100/90 hover:bg-gray-200/90 text-gray-900 border border-gray-200 dark:bg-gray-900/90 dark:hover:bg-gray-800 dark:text-white dark:border-gray-700/80 shadow-sm hover:scale-[1.02]",
    outline:
      "border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-800/80",
  };

  const combinedClassName = `${baseClasses} ${variants[variant]} ${className}`;

  const handleAnchorClick = (e) => {
    if (href && href.startsWith("#")) {
      e.preventDefault();
      const targetId = href.substring(1);
      const elem = document.getElementById(targetId);
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth" });
      }
    }
    if (onClick) {
      onClick(e);
    }
  };

  if (href) {
    const isAnchor = href.startsWith("#");
    return (
      <a
        href={href}
        className={combinedClassName}
        onClick={isAnchor ? handleAnchorClick : onClick}
        target={isAnchor ? undefined : "_blank"}
        rel={isAnchor ? undefined : "noopener noreferrer"}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <button className={combinedClassName} onClick={onClick} {...props}>
      {children}
    </button>
  );
};

export default Button;